import React from 'react';
import { useTranslation } from 'next-i18next';
import { Box } from '@alirosoftware/web-components';

export type ForgotPasswordSentProps = { email: string };

export const ForgotPasswordSent = ({ email }: ForgotPasswordSentProps) => {
  const { t } = useTranslation();
  return (
    <Box className="card card-vertical">
      <h1 className="u-mb-4 u-mt-4">{t('forgotPasswordSent')}</h1>
      <p>{t('forgotPasswordSentDesc').replace('{{email}}', email)}</p>
    </Box>
  );
};
